import { useState, useEffect } from "react";
//Redux
import { useDispatch } from "react-redux";
import { updateFloatPanelVisibility, setFloatPanelData } from "./../../reducers/userConfigSlice";
//Components
import { Textarea } from "@delibrandev/utils";
import { IoMdClose } from "react-icons/io";
import { addIdKeyIfMissing } from "@delibrandev/utils/src/function.js";
import { CartActions } from "../../components/cartActions";
import { getProductInfo } from "../../api/shop";
//Imagenes alergenos
import celery from "../../assets/allergens/celery.png";
import crustaceans from "../../assets/allergens/crustaceans.png";
import eggs from "../../assets/allergens/eggs.png";
import fish from "../../assets/allergens/fish.png";
import gluten from "../../assets/allergens/gluten.png";
import lactose from "../../assets/allergens/lactose.png";
import lupin from "../../assets/allergens/lupin.png";
import molluscs from "../../assets/allergens/molluscs.png";
import mustard from "../../assets/allergens/mustard.png";
import nuts from "../../assets/allergens/nuts.png";
import peanuts from "../../assets/allergens/peanuts.png";
import sesame from "../../assets/allergens/sesame.png";
import soy from "../../assets/allergens/soy.png";
import sulfites from "../../assets/allergens/sulfites.png";

export const FloatComponent = ({ data }) => {
  const [productData, setProductData] = useState({});
  const dispatch = useDispatch();

  const [itemIds, setItemIds] = useState([]);
  const [variantId, setVariantId] = useState("");
  const [note, setNote] = useState("");

  const closeFloatPanelVisibility = () => {
    dispatch(updateFloatPanelVisibility());
    dispatch(setFloatPanelData({}));
  };

  /*********** API REQUESTS ************/
  const queryGet = async () => {
    try {
      const response = await getProductInfo(data.productId);

      if (response && !response.error) {
        let processedData;

        if (Array.isArray(response.data)) {
          processedData = addIdKeyIfMissing(response.data);
        } else if (typeof response.data === "object") {
          processedData = addIdKeyIfMissing([response.data])[0]; // Tomamos el primer (y único) objeto
        } else {
          console.error("Tipo de dato no reconocido:", typeof response.data);
          processedData = {};
        }

        setProductData(processedData);
      }
    } catch (error) {
      console.error("Error obteniendo la información del producto:", error);
      setProductData({});
    }
  };

  useEffect(() => {
    queryGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleVariationPrice = (data = null) => {
    const itemsPriceTotal = () => {
      return data?.itemGroups?.reduce((total, group) => {
        const groupTotal = group.items
          .filter((item) => itemIds.includes(item.itemId)) // Filtra los items que están en itemIds
          .reduce((sum, item) => sum + item.price, 0); // Suma sus precios

        return total + groupTotal;
      }, 0);
    };
    const itemsPrice = itemsPriceTotal();
    const variantPrice = data?.variants?.filter((f) => f.variantId === variantId)?.price || 0;
    return itemsPrice + variantPrice;
  };

  const Content = () => {
    const allergenImages = {
      celery,
      crustaceans,
      eggs,
      fish,
      gluten,
      lactose,
      lupin,
      molluscs,
      mustard,
      nuts,
      peanuts,
      sesame,
      soy,
      sulfites,
    };

    const allergenNames = {
      celery: "Apio",
      crustaceans: "Crustáceos",
      eggs: "Huevos",
      fish: "Pescado",
      gluten: "Gluten",
      lactose: "Lactosa",
      lupin: "Altramuces",
      molluscs: "Moluscos",
      mustard: "Mostaza",
      nuts: "Frutos secos",
      peanuts: "Cacahuetes",
      sesame: "Sésamo",
      soy: "Soja",
      sulfites: "Sulfitos",
    };

    const allergens = productData.allergens?.allergens || productData.allergens || {};
    const hasAllergens = Object.values(allergens).some((value) => value);

    const handleOption = (item) => {
      console.log("handleOption: ", item);
      setItemIds((prevItemIds) => {
        if (prevItemIds.includes(item.itemId)) {
          // Si ya existe, lo eliminamos
          return prevItemIds.filter((id) => id !== item.itemId);
        } else {
          // Si no existe, lo añadimos
          return [...prevItemIds, item.itemId];
        }
      });
    };

    return (
      <div className="details-content">
        <div className="details-image" style={{ backgroundImage: data?.images?.[0] ? `url('${data.images[0]}')` : "no" }}></div>
        <div className="details-name">{productData.name}</div>
        {productData.description && <div className="details-description">{productData.description}</div>}
        {hasAllergens && (
          <div className="details-allergen-list">
            {Object.entries(allergens)
              .filter(([_, value]) => value)
              .map(([key]) => (
                <div key={key} className="allergen-item">
                  <img src={allergenImages[key]} alt={key} className="allergen-icon" />
                  <p className="allergen-name">{allergenNames[key] || key}</p>
                </div>
              ))}
          </div>
        )}

        <div className="details-block">
          <div className="details-name">{`Combinaciones`}</div>
          <div className="details-block-list">
            {productData.variants?.map((group) =>
              group.options?.map(
                (item, i) =>
                  item.name !== "" && (
                    <div key={i} className="item-container">
                      <div className="item-check">
                        <input
                          type="radio"
                          name={`variant`}
                          className="item-checkbox"
                          onClick={() => setVariantId(group.variantId)}
                        />
                      </div>
                      <div className="item-info">
                        <div>{`${item.name} y ${item.optionGroup.name}`}</div>
                        <div className="item-price">+{item.price || 0} €</div>
                      </div>
                    </div>
                  ),
              ),
            )}
          </div>
        </div>

        {productData.itemGroups?.map((group, index) => (
          <div key={index} className="details-block">
            <div className="details-name">{group.name || `Completa tu pedido`}</div>
            <div className="">{group.description || ``}</div>
            <div className="details-block-list">
              {group.items?.map(
                (item, i) =>
                  item.name !== "" && (
                    <div key={i} className="item-container">
                      <div className="item-check">
                        <input
                          id={item.itemId}
                          checked={itemIds.includes(item.itemId)}
                          type="checkbox"
                          name={`group-${index}`}
                          className="item-checkbox"
                          onChange={() => handleOption(item)}
                        />
                      </div>
                      <div className="item-info">
                        <div>{item.name}</div>
                        <div className="item-price">+{item.price || 0} €</div>
                      </div>
                    </div>
                  ),
              )}
            </div>
          </div>
        ))}

        <div className="details-block">
          <div className="details-name">Añadir notas</div>
          <Textarea id="notes" onChange={(e) => setNote(e.target.value)} />
        </div>

        <div className="details-block">
          <div className="details-resume">
            <div className="details-resume-total">{(productData.price + handleVariationPrice(productData) || 0).toFixed(2)}€</div>
            <div className="details-resume-actions">
              <CartActions data={data} itemIds={itemIds} variantId={variantId} note={note} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="floatPanelHeader">
        <div className="floatPanelHeaderLeft">
          <div></div>
        </div>
        <div className="floatPanelHeaderRight">
          <button type="button" onClick={closeFloatPanelVisibility} className="floatPanelCloseButton" aria-label="Cerrar panel">
            <IoMdClose />
          </button>
        </div>
      </div>

      <div className="floatPanelBody">{<Content />}</div>
    </>
  );
};
